import React from "react"
import PropTypes from "prop-types"
import defaultPlaceholder from "../images/image-placeholder.png"
import "./image-element.css"

function disableOptimization(src) {
  if (!src.includes("filekitcdn.com")) return src

  const separator = src.includes("?") ? "&" : "?"
  return src + separator + "auto="
}

export const ImageElement = props => {
  const placeholder = props.placeholder || defaultPlaceholder
  const srcWithOptions =
    props.src && props.optimize === false
      ? disableOptimization(props.src)
      : props.src
  const src = props.editing ? srcWithOptions || placeholder : srcWithOptions

  const onKeyPress = event => {
    if (event.key === "Enter") {
      props.onClick()
    }
  }

  return src ? (
    <div
      className={`${props.className} formkit-image relative focus:outline-none`}
      onKeyPress={onKeyPress}
      onClick={props.onClick}
      role="button"
      tabIndex="0"
    >
      <img
        className={`cursor-pointer focus:outline-blue ${
          src === placeholder ? "image-element--placeholder" : ""
        }`}
        style={{ ...props.style, maxWidth: "100%" }}
        src={src}
        alt={props.alt}
      />
    </div>
  ) : null
}

ImageElement.className = PropTypes.string
ImageElement.editing = PropTypes.bool
ImageElement.onChange = PropTypes.func
ImageElement.onClick = PropTypes.func
ImageElement.src = PropTypes.string
ImageElement.style = PropTypes.object
ImageElement.placeholder = PropTypes.string
